import React from 'react';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiMapPin, FiPhone, FiClock } = FiIcons;

const Footer = () => {
  const googleMapsUrl = "https://www.google.com/maps/place/Ganda+Sushi/@40.726154,-73.789221,17z/data=!3m1!4b1!4m6!3m5!1s0x89c26100ca7163ad:0x4b7fe7e097bf9f58!8m2!3d40.726154!4d-73.789221!16s%2Fg%2F1thsb8h7?entry=ttu&g_ep=EgoyMDI2MDEwNC4wIKXMDSoKLDEwMDc5MjA3MUgBUAM%3D";
  const phoneNumber = "(718) 380-1818";
  const telLink = "tel:+17183801818";

  return (
    <footer className="bg-white border-t border-luxury-gold/10 pt-24 pb-12 text-luxury-dark">
      <div className="max-w-7xl mx-auto px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-16 mb-20">
          <div className="space-y-8">
            <Link to="/" className="flex items-center gap-4 group">
              <div className="h-12 w-12">
                <img 
                  src="https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1757795425239-ganda%20sushi%20logo.png" 
                  alt="Ganda Sushi Logo" 
                  className="w-full h-full object-contain"
                  onError={(e) => { e.target.style.display = 'none'; }}
                />
              </div>
              <span className="text-2xl font-serif tracking-widest block">
                GANDA <span className="text-luxury-gold">SUSHI</span>
              </span>
            </Link>
            <p className="text-luxury-dark/60 text-sm leading-relaxed font-light">
              Elevating the Asian fusion experience through tradition, precision, and the finest ingredients.
            </p>
          </div>

          <div>
            <h4 className="text-[10px] font-black tracking-[0.4em] uppercase text-luxury-gold mb-10">Contact</h4>
            <ul className="space-y-6 text-sm text-luxury-dark/70 font-light">
              <li>
                <a 
                  href={googleMapsUrl} 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="flex items-start gap-4 hover:text-luxury-gold transition-colors duration-300 group"
                >
                  <SafeIcon icon={FiMapPin} className="text-luxury-gold mt-1 shrink-0 group-hover:scale-110 transition-transform" />
                  <span>80-08 Surrey Pl, Jamaica, NY 11432</span>
                </a>
              </li>
              <li>
                <a 
                  href={telLink} 
                  className="flex items-center gap-4 hover:text-luxury-gold transition-colors duration-300 group"
                >
                  <SafeIcon icon={FiPhone} className="text-luxury-gold shrink-0 group-hover:scale-110 transition-transform" />
                  <span>{phoneNumber}</span>
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-[10px] font-black tracking-[0.4em] uppercase text-luxury-gold mb-10">Hours</h4>
            <ul className="space-y-4 text-sm text-luxury-dark/70 font-light">
              <li className="flex justify-between border-b border-luxury-gold/5 pb-2">
                <span>Tue - Sat</span>
                <span className="text-luxury-dark font-medium">11:00 AM - 9:00 PM</span>
              </li>
              <li className="flex justify-between border-b border-luxury-gold/5 pb-2">
                <span>Sunday</span>
                <span className="text-luxury-dark font-medium">12:00 PM - 9:00 PM</span>
              </li>
              <li className="flex justify-between">
                <span>Monday</span>
                <span className="text-luxury-dark font-medium italic opacity-40">Closed</span>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-[10px] font-black tracking-[0.4em] uppercase text-luxury-gold mb-10">Explore</h4>
            <ul className="space-y-4 text-sm">
              {['Menu', 'About', 'Contact', 'Privacy Policy'].map((item) => (
                <li key={item}>
                  <Link 
                    to={item === 'Privacy Policy' ? '/privacy-policy' : `/${item.toLowerCase()}`} 
                    className="text-luxury-dark/70 hover:text-luxury-gold transition-all duration-300 hover:pl-2 font-light"
                  >
                    {item}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="border-t border-luxury-gold/5 pt-12 flex flex-col md:flex-row justify-between items-center gap-6 text-[10px] tracking-[0.2em] uppercase font-black text-luxury-dark/40">
          <div className="space-y-2 text-center md:text-left">
            <p>© 2026 Ganda Sushi. All rights reserved.</p>
            <p>
              Made by <a href="https://mobilefirstpro.com/" target="_blank" rel="noopener noreferrer" className="text-luxury-gold hover:text-luxury-dark transition-colors underline decoration-luxury-gold/30 underline-offset-4">MobileFirstPro</a>
            </p>
          </div>
          <div className="flex gap-8">
            <Link to="/terms-of-use" className="hover:text-luxury-gold transition-colors">Terms</Link>
            <Link to="/cookie-policy" className="hover:text-luxury-gold transition-colors">Cookies</Link>
            <Link to="/accessibility" className="hover:text-luxury-gold transition-colors">Accessibility</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;